const mapStateToProps = (state) => ({
  step: state.asociarUsuarios.step,
});

export default mapStateToProps;
